import * as React from "react";
import { connect } from "react-redux";
import Loader from "../../../components/atoms/Loader";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../../hocs/enhanceSectionsSettingsPage";
import {
  useFetchStudentTags,
  useUpdateStudentTagsCache,
} from "../../../hooks/http/useFetchStudentTags";
import { useQueryError } from "../../../hooks/http/useQueryError";
import AppStateInterface from "../../../interfaces/AppStateInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import SectionsSettingsTags from "./SectionsSettingsTags";

interface OuterProps {
  section: SectionInterface;
}
type Props = OuterProps & OutletContextProps;

const mapStateToProps = (state: AppStateInterface) => ({
  section: state.currentSection,
});

const SectionsSettingsTagsPage = (props: Props) => {
  React.useEffect(() => {
    props.setActiveMenu("tags");
  }, []);

  const query = useFetchStudentTags({
    sectionId: props.section.id,
    enabled: true,
  });
  const { createTag, updateTag, deleteTag } = useUpdateStudentTagsCache(
    props.section.id,
  );
  useQueryError(query.error);

  if (query.isPending || !query.data) {
    return <Loader loading />;
  }

  return (
    <SectionsSettingsTags
      section={props.section}
      tags={query.data.tags}
      createTag={createTag}
      updateTag={updateTag}
      deleteTag={deleteTag}
    />
  );
};

const pageInfo = {
  title: "タグ",
};

const EnhancedPage = enhanceSectionsSettingsPage(
  SectionsSettingsTagsPage,
  pageInfo,
  ["tag:index"],
);

export default connect(mapStateToProps)(EnhancedPage as any);
